/**
 * Comments plan 2 (spec 2026-10-18-comments-design, "Preview mechanics"): the editor's side of the messages with the
 * comment layer in the reader preview. Only the preview frame, from its own origin, is listened to.
 */

import { toThreads } from './comments';

const SOURCE = 'wm-comments';

/** The message's `{ type, payload }`, or null when it is not from the preview frame and its origin. */
export function acceptMessage(event, frameWindow, frameSrc) {
  let origin;
  try {
    origin = new URL(frameSrc).origin;
  } catch (e) {
    return null;
  }
  const data = event && event.data;
  if (!frameWindow || event.source !== frameWindow || event.origin !== origin) return null;
  if (!data || data.source !== SOURCE || typeof data.type !== 'string') return null;
  return { type: data.type, payload: data.payload };
}

/** Open threads with a place in one language (null = main), one pin each, with the thread's number from the list. */
export function pinsFor(rows, languageId) {
  return toThreads(rows, languageId)
    .filter((t) => !t.resolved && t.anchor)
    .map((t) => ({ id: t.id, anchor: t.anchor, number: t.number }));
}

/**
 * Whether opening a language preview writes the draft translation: only for those who may edit the page (an Auditor's
 * write would be refused), and only when the html changed since the last write (each write touches the page row).
 */
export function shouldWriteDraft({ isSysAdmin, privileges }, lastHtml, html) {
  if (!isSysAdmin && !(privileges || []).includes('can_edit_page')) return false;
  return JSON.stringify(lastHtml || null) !== JSON.stringify(html || null);
}

/** The preview's device buttons to the stored device. */
export function deviceOf(deviceName) {
  return deviceName === 'phone' || deviceName === 'tablet' ? deviceName : 'desktop';
}

/** Plan 4: the thread a mail or inbox link opens (`?comment=<id>` on the editor page route), else null. */
export function commentFromRoute(query) {
  const raw = Array.isArray(query && query.comment) ? query.comment[0] : query && query.comment;
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
}
